<div class="clug-page jobs-page">
  <div class="page-head">
    <div class="title-block">
      <h1 class="page-title">Jobs</h1>
      <p class="lede">Create and manage jobs across every client.</p>
    </div>
    <div class="action-bar">
      <button type="button" class="btn btn-primary" (click)="createJob()">
        <i class="bi bi-plus-lg"></i><span>Add New</span>
      </button>
    </div>
  </div>

  <nav class="page-tabs">
    <a class="page-tab" routerLinkActive="active" routerLink="/jobs/active-jobs">Active</a>
    <a class="page-tab" routerLinkActive="active" routerLink="/jobs/inactive-jobs">Inactive</a>
    <a *ngIf="user?.role_uuid === ROLES?.AGENCY || user?.role_uuid === ROLES?.SUPER_ADMIN"
       class="page-tab" routerLinkActive="active" routerLink="/jobs/request-jobs">Requests</a>
  </nav>

  <router-outlet></router-outlet>
</div>
